import React, { useEffect } from 'react'
import {
  useDataChange,
  useDataFormat,
  useDataSubmit,
  useDataValue,
} from 'Simple/Data'
import View from './view.js'
import { DEFAULT_TIMEZONE } from 'Data/constants.js'

export default function Logic(props) {
  let tabId = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'id',
  })

  let syncParams = useDataFormat({
    viewPath: props.viewPath,
    context: 'global',
    path: 'tabs',
    format: value => value.find(item => item.id === tabId)?.sync,
  })

  let globalLocation = useDataValue({
    context: 'global',
    path: 'current_location',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'tab',
  })

  let submitTab = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })

  useEffect(() => {
    if (!syncParams) return

    // If we receive a patient_id or appointment_id,
    // and not just to show an appointment
    // we need to open overlay with this information
    if (
      typeof syncParams.patient_id === 'string' ||
      (typeof syncParams.appointment_id === 'string' &&
        !syncParams.only_show_appointment)
    ) {
      submitTab({
        type: 'appointmentOverlay/open',
        patient_id: syncParams.patient_id,
        is_external_patient_id: !!syncParams.patient_id,
        treatment_id: syncParams.treatment_id,
        is_external_treatment_id: !!syncParams.treatment_id,
        appointment_id: syncParams.appointment_id,
        is_external_appointment_id: !!syncParams.appointment_id,
        is_patient_overlay_call: syncParams.is_patient_overlay_call,
        ...(syncParams.location?.id && {
          location: {
            location_id: syncParams.location._id,
            location_name: syncParams.location.name,
            vaxiom_location_id: syncParams.location.id,
            time_zone_id: syncParams.location.time_zone_id || DEFAULT_TIMEZONE,
          },
        }),
      })
    } else {
      // Otherwise, we set the sync values if necessary
      // Location, date or booking to focus on
      change(next => {
        if (syncParams.location?.id) {
          next.selected.location_id = syncParams.location._id
          next.selected.location_name = syncParams.location.name
          next.selected.vaxiom_location_id = syncParams.location.id
          next.selected.time_zone_id =
            syncParams.location.time_zone_id || DEFAULT_TIMEZONE
        }
        if (syncParams.date) {
          next.selected.date = syncParams.date
        }
        if (syncParams.booking_id) {
          next.focused_event_id = syncParams.booking_id
        }
      })
    }
  }, [syncParams]) // eslint-disable-line

  useEffect(() => {
    change(next => {
      if (
        globalLocation?.id &&
        next.global_location?.id !== globalLocation.id
      ) {
        next.global_location = globalLocation

        next.selected.location_id = globalLocation._id
        next.selected.location_name = globalLocation.name
        next.selected.vaxiom_location_id = globalLocation.id
        next.selected.time_zone_id =
          globalLocation.time_zone_id || DEFAULT_TIMEZONE
        next.selected.appointment_queue = []
      }
    })
  }, [globalLocation]) // eslint-disable-line

  return <View {...props} />
}
